import { useQuery } from "react-query";
import { getProducerCodes } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useProducerCodes = () => {
  return useQuery("GetProducerCodes", getProducerCodes, {
    refetchOnWindowFocus: false,
  });
};
